<template>
  <colored-popup :class="'light-blue'" :back-action="onBack" :dark-text="true">
    <template v-slot:top-content>
      <div class="centered">
        <img class="balance-money-logos" src="/images/saving-zone/balance-money/riseup_plus_fair.svg"/>
        <div class="title margin-top-large">קרן כספית</div>
      </div>
    </template>

    <template v-slot:bottom-content>
      <div class="body-text margin-bottom-x-large">
        כדי לפשט את תהליך רכישת קרן כספית יצרנו <span class="bold">שיתוף פעולה עם חברת fair</span>.
        <div>
          ב־fair תוכלו לבחור מבין מגוון של קרנות נאמנות, וגם קרנות כספיות.
        </div>
        <div class="margin-top-medium margin-bottom-large">
          לרייזאפ אין רווחים משיתוף הפעולה הזה, ונשמח שהלקוחות שלנו ימשיכו לצמוח.
        </div>
        <callout iconPath="icons/info-icon-blue.svg">
          <template v-slot:text>
            רוצה לדעת עוד? אפשר לקרוא מידע נוסף על קרן כספית <a class="link" @click="moreInfoClicked">כאן</a>.
          </template>
        </callout>
      </div>
      <riseup-button
        class="margin-bottom-medium"
        title="לרכישת קרן כספית ב־fair"
        :action="openFair"
        size="slim"
        :bold="true"
      />
    </template>

    <template v-slot:footer v-if="!hideSnooze">
      <div class="centered">
        <a class="link-button" @click="remindMeLaterClicked">
          מעניין, תזכירו לי אח"כ
        </a>
      </div>
    </template>
  </colored-popup>
</template>

<script>
import BaseUI from '@riseupil/base-ui';
import Segment from '@/Segment';

export default {
  name: 'MoneyFundStepIntro',
  components: {
    ColoredPopup: BaseUI.ColoredPopup,
    RiseupButton: BaseUI.RiseupButton,
    Callout: BaseUI.Callout,
  },
  props: {
    onBack: {
      type: Function,
      required: true,
    },
    onDismiss: {
      type: Function,
      required: true,
    },
    stepName: {
      type: String,
      required: true,
    },
    hideSnooze: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    Segment.trackUserInteraction('BalanceMoneyFlow_StepEntered', { step: this.stepName });
  },
  methods: {
    openFair() {
      Segment.trackUserInteraction('BalanceMoneyFlow_ClickedOpenFairWebsite');
      window.open('https://go.fair.co.il/riseup', '_blank');
      this.onDismiss();
    },
    moreInfoClicked() {
      Segment.trackUserInteraction('BalanceMoneyFlow_KerenKaspitArticleClicked');
      window.open('https://intercom.riseup.co.il/he/articles/6817301-%D7%A7%D7%A8%D7%9F-%D7%9B%D7%A1%D7%A4%D7'
        + '%99%D7%AA-%D7%91%D7%95%D7%90%D7%95-%D7%A0%D7%93%D7%91%D7%A8-%D7%A2%D7%9C-%D7%96%D7%94', '_blank');
    },
    remindMeLaterClicked() {
      this.onDismiss(true);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/personalized-savings/balance-money/balance-money-styles";

</style>
